import React from "react";

const projectsData = [
  {
    title: "TrackMyGuard",
    subtitle: "Real-time Security Tracking Platform",
    features: [
      "Real-time Security Guard Tracking using Geofencing & OpenStreetMaps API",
      "Alerts for unauthorized movement and location monitoring",
      "Admin Panel for Guard Management (Add, Edit, Delete guards)",
      "Firebase Authentication & Firestore Database integration",
      "Comprehensive incident reporting and attendance monitoring"
    ],
    tech: "Java, XML, Firebase, OpenStreetMaps API"
  },
  {
    title: "Petaverse",
    subtitle: "All-in-One Pet Care Platform (Institute Funded Startup)",
    features: [
      "Comprehensive pet care services: breeding, training, grooming, selling, adoption",
      "Pet profile management and health tracking system",
      "Location-based pet shelter search with real-time data",
      "Marketplace for pet accessories and community engagement",
      "YouTube integration for training videos and educational content"
    ],
    tech: "Java, XML, Firebase, Volley, Picasso"
  },
  {
    title: "SustainCity",
    subtitle: "Community Engagement App (GDG Solutions Challenge 2025)",
    features: [
      "Community-driven app for complaint reporting and food donation",
      "Volunteer events management and bike rental system",
      "Role-based dashboards for citizens, NGOs"
    ],
    tech: "Java, Firebase, OpenStreetMaps, REST APIs"
  }
  // Add more objects as needed
];

function Projects() {
  return (
    <section id="projects">
      <div className="container">
        <h2 className="section-title">Featured Projects</h2>
        <div className="projects-grid">
          {projectsData.map((proj, idx) => (
            <div className="project-card" key={idx}>
              <div className="project-header">
                <h4>{proj.title}</h4>
                <p>{proj.subtitle}</p>
              </div>
              <div className="project-content">
                <ul className="project-features">
                  {proj.features.map((feature, i) => (
                    <li key={i}>{feature}</li>
                  ))}
                </ul>
                <div className="project-tech">
                  <strong>Tech Stack:</strong> <span>{proj.tech}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Projects;
